import { Component } from '@angular/core';
import type { CoverpathAnnuity } from '../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathAnnuity';
import { productTypes } from '../../../../../common/js/static/Product';
import { Utils } from '../../../../../common/js/Utils';
import { CoverpathControllerInterface } from '../../../interfaces/controller/CoverpathControllerInterface';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { AccountCenterSection } from '../utilities/accountCenterSection.component';

@Component({
  selector: 'annuity-summary',
  moduleId: module.id,
  templateUrl: './annuity-summary.component.html',
})
export class AnnuitySummaryComponent extends AccountCenterSection {
  controller: CoverpathControllerInterface;
  initialized: boolean = false;
  initialPurchaseAmount: number;

  constructor(amorphicService: AmorphicService, accountCenterService: AccountCenterService) {
    super(amorphicService, accountCenterService);
    this.controller = amorphicService.controller;
    const primaryPolicy = accountCenterService.application.primaryPolicy as CoverpathAnnuity;
    this.initialPurchaseAmount = primaryPolicy.initialPurchaseAmount;
  }

  ngOnInit(): void {
    this.subscribeToAccountCenterService();
  }

  getProductName(): string {
    return productTypes.Annuity.productNames[this.accountCenterService.application.primaryPolicy.product];
  }
}
